var error = {
  translation: {
    error: {
      coreNotFound: 'コア設定の取得に失敗しました',
      domainNotAllowed: 'このドメインのメールでは登録できません',
      emailAlreadyInUse: 'このメールアドレスは既に使用されています',
      insufficientPermissions: '権限不足',
      invalidCurrentPassword: '現在のパスワードが正しくありません',
      invalidPermissions: '少なくとも1つの権限を選択してください',
      invalidUsernameOrPassword: 'ユーザー名またはパスワードが正しくありません',
      localRegistrationDisabled: 'ローカルユーザー登録は管理者によって無効化されています',
      noInternetConnection: 'インターネット接続がありません',
      noOidcProfileFound: 'OIDC プロファイルが見つかりません',
      policyNotAccepted: '利用規約とプライバシーポリシーに同意してください',
      registrationDisabled: 'ユーザー登録は管理者によって無効化されています',
      serverConnectionFailed: 'サーバーへの接続に失敗しました',
      ssoRegistrationDisabled: 'SSO登録は管理者によって無効化されています',
      tooManyFailedAttempts: '失敗した試行が多すぎます - 後でもう一度お試しください',
      unknownError: '不明なエラー、後でもう一度お試しください',
      usernameAlreadyInUse: 'このユーザー名は既に使用されています',
      weakPassword: 'より強いパスワードを使用してください',
    },
  },
};

export { error as default };
